export default ({ dictateState }) => dictateState;
